import { defineStore } from 'pinia';
import useStore from '@/store';
import { ref } from 'vue';
import { Resource } from '@/entities';

export default defineStore('resource', () => {
  const rootStore = useStore();
  const resources = ref<Resource[]>([]);
  const isLoading = ref(false);

  return {
    resources,
    isLoading,

    async init() {},
    async getResources() {
      isLoading.value = true;
      const data = await rootStore.apiService.resource.fetchResource();

      if (data) {
        resources.value = data.map((resourceData) => new Resource(resourceData));
      }
      isLoading.value = false;
    }
  };
});
